import { Link } from "react-router-dom";

export const Logo = ({ light = false, className = "" }) => {
  const gold = "#C5A059";
  const navy = light ? "#FFFFFF" : "#0B1B3D";
  return (
    <Link to="/" className={`flex items-center gap-3 group ${className}`} data-testid="logo-link">
      <svg width="44" height="44" viewBox="0 0 64 64" fill="none" className="shrink-0 transition-transform duration-300 group-hover:scale-105">
        <rect x="2" y="2" width="60" height="60" stroke={gold} strokeWidth="1.5" />
        <rect x="7" y="7" width="50" height="50" stroke={gold} strokeWidth="0.75" opacity="0.6" />
        <text x="32" y="41" textAnchor="middle" fontFamily="Cormorant Garamond, serif" fontSize="30" fontWeight="600" fill={navy}>PA</text>
      </svg>
      <div className="leading-none">
        <div className="font-serif text-xl font-semibold tracking-tight" style={{ color: navy }}>Palumbo Academy</div>
        <div className="text-[0.62rem] uppercase tracking-[0.28em] font-bold" style={{ color: gold }}>Sindacato Scuola</div>
      </div>
    </Link>
  );
};

export default Logo;
